"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _finance = require("@/api/finance");
var _merchantName = _interopRequireDefault(require("@/components/merchantName"));
var _auth = require("@/utils/auth");
var _systemSetting = require("@/api/systemSetting");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'transferAccount',
  data: function data() {
    return {
      myHeaders: {
        'X-Token': (0, _auth.getToken)()
      },
      isShow: 0,
      loadingBtn: false,
      rules: {
        auditStatus: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        refusalReason: [{
          required: true,
          message: '请填写拒绝原因',
          trigger: 'blur'
        }],
        closingProof: [{
          required: true,
          message: '请上传结算凭证',
          type: 'array',
          trigger: 'change'
        }]
      },
      tableData: {
        data: [],
        total: 0
      },
      arrivalStatusList: [{
        label: '已到账',
        value: 1
      }, {
        label: '未到账',
        value: 0
      }],
      closingTypeList: [{
        label: '银行卡',
        value: 'bank'
      }, {
        label: '微信',
        value: 'wechat'
      }, {
        label: '支付宝',
        value: 'alipay'
      }],
      listLoading: true,
      tableFrom: {
        dateLimit: '',
        page: 1,
        limit: 20,
        keywords: '',
        auditStatus: '',
        accountStatus: '',
        closingType: ''
      },
      keywords: '',
      timeVal: [],
      fromList: this.$constants.fromList,
      loading: false,
      dialogVisible: false,
      pictureVisible: false,
      closingData: {},
      baseInfoform: {
        amount: 0,
        mark: '',
        transferType: ''
      },
      merchantList: [],
      search: {
        limit: 10,
        page: 1,
        keywords: ''
      },
      ruleForm: {
        refusalReason: '',
        auditStatus: 1,
        id: '',
        closingProof: []
      },
      localImg: ''
    };
  },
  components: {
    merchantName: _merchantName.default
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:finance:user:closing:page:list'])) this.getList(1);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    onRemark: function onRemark(row) {
      var _this = this;
      this.$modalPrompt('textarea', '备注', row.mark).then(function (V) {
        (0, _finance.userClosingRemarkApi)({
          closingNo: row.closingNo,
          remark: V
        }).then(function (res) {
          _this.$message({
            type: 'success',
            message: '提交成功'
          });
          _this.getList('');
        });
      });
    },
    // 审核提交
    onSubmit: function onSubmit(type) {
      var _this2 = this;
      if (type === 'success') {
        this.$modalSure('通过此佣金提现吗？').then(function () {
          _this2.ruleForm.auditStatus = 1;
          _this2.submit();
        });
      } else {
        this.ruleForm.auditStatus = 2;
        this.cancelForm();
      }
    },
    //审核拒绝
    cancelForm: function cancelForm() {
      var _this3 = this;
      this.$modalPrompt('textarea', '拒绝原因').then(function (V) {
        _this3.ruleForm.refusalReason = V;
        _this3.submit();
      });
    },
    submit: function submit() {
      var _this4 = this;
      if (this.isShow === 2) {
        this.$refs.ruleForm.validate(function (valid) {
          if (valid) {
            _this4.loadingBtn = true;
            var data = {
              closingNo: _this4.closingData.closingNo,
              refusalReason: _this4.ruleForm.refusalReason,
              auditStatus: _this4.ruleForm.auditStatus
            };
            (0, _finance.userClosingAuditApi)(data).then(function (res) {
              _this4.$message.success('操作成功');
              _this4.dialogVisible = false;
              _this4.getList(1);
              _this4.close('ruleForm');
              _this4.loadingBtn = false;
            }).catch(function (res) {
              _this4.loadingBtn = false;
            });
          } else {
            return false;
          }
        });
      } else {
        this.loadingBtn = true;
        var data = {
          closingNo: this.closingData.closingNo,
          closingProof: JSON.stringify(this.ruleForm.closingProof)
        };
        this.$refs.ruleForm.validate(function (valid) {
          if (valid) {
            (0, _finance.userClosingProofApi)(data).then(function (res) {
              _this4.$message.success('操作成功');
              _this4.dialogVisible = false;
              _this4.getList(1);
              _this4.close('ruleForm');
              _this4.loadingBtn = false;
            }).catch(function (res) {
              _this4.loadingBtn = false;
            });
          }
        });
      }
    },
    handleUploadForm: function handleUploadForm(param) {
      var _this5 = this;
      var formData = new FormData();
      var data = {
        model: 'finance',
        pid: 0
      };
      formData.append('multipart', param.file);
      var loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _systemSetting.fileImageApi)(formData, data).then(function (res) {
        loading.close();
        _this5.$message.success('上传成功');
        _this5.ruleForm.closingProof.push(res.url);
      }).catch(function (res) {
        loading.close();
      });
    },
    handleRemove: function handleRemove(i) {
      this.ruleForm.closingProof.splice(i, 1);
    },
    close: function close(refName) {
      this.dialogVisible = false;
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
      this.ruleForm.closingProof = [];
      this.loadingBtn = false;
    },
    // 商户结算记录详情
    closingDetail: function closingDetail(row, num) {
      this.isShow = num;
      this.closingData = row;
      this.dialogVisible = true;
    },
    // 查看图片
    getPicture: function getPicture(url) {
      this.pictureVisible = true;
      this.pictureUrl = url;
    },
    // 选择时间
    selectChange: function selectChange(tab) {
      this.tableFrom.dateLimit = tab;
      this.timeVal = [];
      this.getList(1);
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.tableFrom.dateLimit = e ? this.timeVal.join(',') : '';
      this.getList(1);
    },
    // 导出
    exportRecord: function exportRecord() {
      var _this6 = this;
      (0, _finance.transferRecordsExportApi)(this.tableFrom).then(function (res) {
        var h = _this6.$createElement;
        _this6.$msgbox({
          title: '提示',
          message: h('p', null, [h('span', null, '文件正在生成中，请稍后点击"'), h('span', {
            style: 'color: teal'
          }, '导出记录'), h('span', null, '"查看~ ')]),
          confirmButtonText: '我知道了'
        }).then(function (action) {});
      }).catch(function (res) {
        _this6.$message.error(res.message);
      });
    },
    // 导出列表
    getExportFileList: function getExportFileList() {
      this.$refs.exportList.exportFileList();
    },
    // 列表
    getList: function getList(num) {
      var _this7 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.tableFrom.keywords = encodeURIComponent(this.keywords);
      (0, _finance.userClosingListApi)(this.tableFrom).then(function (res) {
        _this7.tableData.data = res.list;
        _this7.tableData.total = res.total;
        _this7.listLoading = false;
      }).catch(function (res) {
        _this7.listLoading = false;
      });
    },
    reset: function reset() {
      this.keywords = '';
      this.tableFrom = {
        dateLimit: '',
        page: 1,
        limit: 20,
        keywords: '',
        auditStatus: '',
        accountStatus: '',
        closingType: ''
      };
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList('');
    },
    handleClose: function handleClose() {
      this.dialogLogistics = false;
    }
  }
};